import { IonBadge, IonContent, IonSpinner } from "@ionic/react";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { Attachments } from "../../components/Attachments";
import { PageHeader } from "../../components/PageHeader";
import { BasicTemplate } from "../../components/PageTemplates";
import { TrixContent } from "../../components/TrixContent";
import { ApiService } from "../../services";
export const File = (props: any) => {
  const { isPending, isLoading, data } = useQuery({
    queryKey: ["file", props.match.params?.file],
    queryFn: async () => {
      const fileId = props.match.params?.file || "";
      return await ApiService.get(`resources/files/${fileId}`);
    },
  });
  const [title, setTitle] = useState<string>(props.match.params?.title);

  useEffect(() => {
    setTitle(props.match.params?.title);
  }, [props.match.params?.title]);

  useEffect(() => {
    if (data && data.data && data.data.title) {
      setTitle(data.data.title);
    }
  }, [data, data?.data, data?.data?.title]); // this is dumb, there must be a better way

  return (
    <BasicTemplate hideHeader={false} hideBackButton={false} title={title}>
      <IonContent className={"ion-padding"}>
        <PageHeader collapse={"condense"}>{title}</PageHeader>

        {isPending || isLoading ? (
          <IonSpinner name="dots" className={"block ion-text-center ion-margin-top"} />
        ) : data?.data ? (
          <>
            {data.data.content && <TrixContent content={data.data.content} />}

            {data.data.attachments && data.data.attachments.length ? (
              <>
                <h5 className={"separator-heading"}>
                  Attachments <IonBadge>{data.data.attachments.length}</IonBadge>
                </h5>
                <Attachments attachments={data.data.attachments} />
              </>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}
      </IonContent>
    </BasicTemplate>
  );
};
